import { render } from "./EachItemModifications.vue?vue&type=template&id=7771bea4"
import script from "./EachItemModifications.vue?vue&type=script&lang=js"
export * from "./EachItemModifications.vue?vue&type=script&lang=js"

import "./EachItemModifications.vue?vue&type=style&index=0&id=7771bea4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__